<svelte:options runes={true} />

<script lang="ts">
  // Double-rule horizontal divider with higher contrast using Shoelace neutral palette.
  // Renders two 1px lines separated by a 1px gap. Thickness prop scales both lines proportionally (>=1).
  let {
    thickness = 1,
    colorTop = 'var(--sl-color-neutral-500)',
    colorBottom = 'var(--sl-color-neutral-500)',
    gap = 2,
    margin = '6px 0'
  }: {
    thickness?: number; // base thickness per rule
    colorTop?: string;
    colorBottom?: string;
    gap?: number; // gap between the two rules in px
    margin?: string;
  } = $props();

  const totalHeight = $derived(thickness * 2 + gap);
</script>

<div
  style={`display:flex; flex-direction:column; justify-content:center; margin:${margin}; width:100%; height:${totalHeight}px;`}
>
  <div style={`height:${thickness}px; background:${colorTop}; width:100%;`}></div>
  <div style={`height:${gap}px; width:100%;`}></div>
  <div style={`height:${thickness}px; background:${colorBottom}; width:100%;`}></div>
</div>
